import { CoachBrowserDomGateway } from '@mojility/coach-core';

export default {
  name: 'coachBrowserDomGateway',
  fn: CoachBrowserDomGateway
}